// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  env: 'development',
  appName: 'Spotlight',
  uiRedirectUrl: 'https://dev.spotlight.cfahome.com/login/callback', // Development UI URL
  oktaClientId: '0oa1elkry0tMPlkK40h8',
  oktaAuthUrl: 'https://cfahome.oktapreview.com', // Development Okta Auth URL
  oktaAuthIssuer: 'https://cfahome.oktapreview.com/oauth2/auscjsakz3PaAP82K0h7',
  endSessionRedirectUri: 'https://dev.spotlight.cfahome.com/logged-out',
  spotlightApiUrl: 'https://spotlight.dxe.dev.crndev.chick-fil-a.com',
  eventMetricsUrl: 'https://dev.spotlight.cfahome.com',
  digitalMarketingCampaignsServiceURL:  'https://dev.spotlight.api.chick-fil-a.com/digital-marketing',
  digitalMarketingAudienceServiceURL:  'https://dev.spotlight.api.chick-fil-a.com/audience',
  d2cUrl: 'https://d2c.api.dev.crndev.chick-fil-a.com',
  urlsForJWTHeader: [
    'https://d2c.api.dev.crndev.chick-fil-a.com',
  ],
  urlsForAuthHeader: [
    'https://spotlight.dxe.dev.crndev.chick-fil-a.com',
    'https://dev.spotlight.api.chick-fil-a.com',
    'https://dev.spotlight.cfahome.com'
  ],
  launchDarklyClientId: '66ba3d3585f49910a5420c65',
  amplitudeApiKey: '',
  pendoApiKey: '34a036c2-887a-4887-a841-8f3263d572e5'
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
